module.exports = __webpack_public_path__ + "static/media/1Palle.40ab3740.jpeg";